import { getBlock } from "@src/packages/content";
import type { ContentBlock, ContentBlockId } from "@src/packages/content";

const FACT_SHEET_ID_PREFIX = {
  condition: "condition-",
  medication: "med-",
  procedure: "proc-",
  program: "program-",
  supplement: "supplement-",
  therapy: "therapy-",
} as const;

type PrefixableFactSheetKind = keyof typeof FACT_SHEET_ID_PREFIX;

export function getFactSheetRouteBlock<K extends PrefixableFactSheetKind>(
  kind: K,
  routeId: string,
): ContentBlock<K> | null {
  const prefix = FACT_SHEET_ID_PREFIX[kind];
  const candidateIds = routeId.startsWith(prefix)
    ? [routeId]
    : [routeId, `${prefix}${routeId}`];

  for (const candidateId of candidateIds) {
    const block = getBlock(candidateId as ContentBlockId);
    if (block?.kind === kind) return block as ContentBlock<K>;
  }

  return null;
}
